import {SET_PAKKET_FILTERS, SET_FILTERS, CLEAR_FILTERS, SET_SUB_FILTERS, CLEAR_SUB_FILTERS, HANDLE_SEARCH } from './actionTypes'

export const setFilters = (filters) => ({
  type: SET_FILTERS,
  payload: filters
})

export const setPakketFilters = (filters) => ({
  type: SET_PAKKET_FILTERS,
  payload: filters
})

export const clearFilters = () => ({
  type: CLEAR_FILTERS
})

export const setAttrFilter = (filters) => ({
  type: SET_SUB_FILTERS,
  payload: filters
})

export const clearAttrFilter = () => ({
  type: CLEAR_SUB_FILTERS
})

export const handleSearch = (value) => ({
  type: HANDLE_SEARCH,
  payload: value
})
